import React, { useEffect, useState } from 'react';
import {
  AppShell as AppShellQitUI,
  ModalProvider,
  PageWrapper,
  QitUiProvider,
  useWindowProperties,
} from '@qred/qit-ui';
import { AppShell, ComponentsLibraryProvider } from '@qred/components-library';
import SidebarContent from '~/components/shared/Sidebar/SidebarContent';
import { useDispatch, useSelector } from 'react-redux';
import { pushToGtmAction } from '~/store/actions/gtmActions';
import { StepStatus } from '~/enums';
import { RootState } from '~/store/types/sharedTypes';
import { appShellSidebar } from '~/constants/cy/components/sidebar';
import Header from '~/components/shared/Sidebar/SidebarHeaderLoggedOut';
import { useAuth0 } from '@auth0/auth0-react';
import SidebarContentLoggedOut from '../Sidebar/SidebarContentLoggedOut';
import SpinnerCircular from '../Spinner/SpinnerCircular';

const MainLayoutNewStyle: React.FC = ({ children }) => {
  const { activeCompany } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const [eventStarted, setEventStarted] = useState(false);
  const { isMobile, isTablet } = useWindowProperties();
  const { isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!eventStarted && activeCompany) {
      dispatch(
        pushToGtmAction({
          eventName: 'sidebar',
          actionName: 'view_sidebar',
          stepStatus: StepStatus.Started,
        })
      );
      setEventStarted(true);
    }
  }, [activeCompany?.id]);

  if (isLoading) {
    return <SpinnerCircular />;
  }

  return (
    <QitUiProvider>
      <ModalProvider>
        <ComponentsLibraryProvider>
          {isAuthenticated ? (
            <AppShellQitUI
              isMobileOrTablet={isMobile || isTablet}
              navbarContent={<SidebarContent />}
              dataCy={appShellSidebar}
              navbarWidth="260px"
            >
              <PageWrapper>{children}</PageWrapper>
            </AppShellQitUI>
          ) : (
            <AppShell
              navbar={<SidebarContentLoggedOut />}
              dataCy={appShellSidebar}
              header={<Header />}
            >
              <PageWrapper>{children}</PageWrapper>
            </AppShell>
          )}
        </ComponentsLibraryProvider>
      </ModalProvider>
    </QitUiProvider>
  );
};

export default MainLayoutNewStyle;
